import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class BeniUpsell extends Model {
  [Type] = 'benchmark-insight/upsell' as const;

  @attr('boolean') declare lightRequested: boolean;
  @attr('boolean') declare trialRequested: boolean;
}
